angular.module('ApptBookApp').controller('ClientHistoryController', ['$scope', '$http', '$rootScope', 'restServer', 'appointmentBookModalService',
  'clientId', 'meevo.components.modal.ModalService',
    function ($scope, $http, $rootScope, restServer, modal, clientId, modalService) {

    $scope.modal = modal;
    $scope.modalService = modalService;
    $scope.clientId = clientId;
    $scope.hide = function () {
      $scope.modal.hideModal();
    }

    $scope.viewAuditDetail = function (appointmentId: Meevo.Guid) {

      let options: Meevo.Components.Modal.IModalOptions = {
        templateUrl: "app/plugins/AppointmentBook/views/AppointmentAuditLog.html",
        controller: "AppointmentAuditLogController",
        controllerAs: undefined,
        bindToController: true,
        locals: {
            appointmentId: appointmentId,
            appointmentServiceScheduleId: undefined,
            appointmentRequestId: undefined
        }
      }

      $scope.modalService.showCustom(options);
    }
  }
]);
